export async function loadStripeScript() {
  return new Promise(resolve => {
    const script = document.createElement('script');

    script.src = 'https://js.stripe.com/v3/';

    script.onload = resolve;

    if (document.body) {
      document.body.appendChild(script);
    } else {
      document.addEventListener('DOMContentLoaded', () => document.body.appendChild(script));
    }
  });
}
